import React, { useState } from 'react';
import './PostEditor.css';

interface PostEditorProps {
  post?: any;
  onSave: (postData: any) => void;
  onCancel: () => void;
}

const PostEditor: React.FC<PostEditorProps> = ({ post, onSave, onCancel }) => {
  const [title, setTitle] = useState(post?.title || '');
  const [content, setContent] = useState(post?.content || '');
  const [category, setCategory] = useState(post?.category || 'notice');
  const [isPinned, setIsPinned] = useState(post?.is_pinned || false);

  const handleSave = () => {
    if (!title.trim() || !content.trim()) {
      alert('제목과 내용을 입력해주세요.');
      return;
    }

    onSave({
      title: title.trim(),
      content: content.trim(),
      category,
      is_pinned: isPinned
    });
  };

  return (
    <div className="post-editor-modal">
      <div className="post-editor">
        <div className="editor-header">
          <h3>{post ? '게시글 수정' : '게시글 작성'}</h3>
          <button className="close-button" onClick={onCancel}>×</button>
        </div>

        <div className="editor-form">
          <div className="form-row">
            <div className="post-editor-group">
              <label>카테고리</label>
              <select value={category} onChange={(e) => setCategory(e.target.value)}>
                <option value="notice">공지사항</option>
                <option value="study">스터디</option>
                <option value="code">코드공유</option>
                <option value="general">일반</option>
              </select>
            </div>
            <div className="post-editor-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={isPinned}
                  onChange={(e) => setIsPinned(e.target.checked)}
                />
                상단 고정
              </label>
            </div>
          </div>

          <div className="post-editor-group">
            <label>제목</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="제목을 입력하세요"
              maxLength={100}
            />
          </div>

          <div className="post-editor-group">
            <label>내용</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="내용을 입력하세요&#10;&#10;링크는 자동으로 클릭 가능하게 변환됩니다.&#10;예: https://aws.amazon.com"
              rows={15}
            />
          </div>

          <div className="editor-actions">
            <button className="post-editor-save" onClick={handleSave}>
              {post ? '수정' : '작성'} 완료
            </button>
            <button className="post-editor-cancel" onClick={onCancel}>
              취소
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostEditor;